module.exports = __webpack_public_path__ + "img/laptop.c008c447.png";